import { Container, Divider } from './Footer.styled'

export const Footer = () => {
  return (
    <Container>
      <Divider />
    </Container>
  )
}
